/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StationaryUnitType } from './StationaryUnitType';
import {
    StationaryUnitTypeFromJSON,
    StationaryUnitTypeFromJSONTyped,
    StationaryUnitTypeToJSON,
    StationaryUnitTypeToJSONTyped,
} from './StationaryUnitType';

/**
 * 
 * @export
 * @interface StationaryUnit
 */
export interface StationaryUnit {
    /**
     * 
     * @type {string}
     * @memberof StationaryUnit
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof StationaryUnit
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof StationaryUnit
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof StationaryUnit
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof StationaryUnit
     */
    serialNumber: string;
    /**
     * 
     * @type {StationaryUnitType}
     * @memberof StationaryUnit
     */
    stationaryUnitType: StationaryUnitType;
    /**
     * 
     * @type {Date}
     * @memberof StationaryUnit
     */
    firmwareLastUpdatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof StationaryUnit
     */
    firmwareCurrentVersion: string;
}



/**
 * Check if a given object implements the StationaryUnit interface.
 */
export function instanceOfStationaryUnit(value: object): value is StationaryUnit {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('serialNumber' in value) || value['serialNumber'] === undefined) return false;
    if (!('stationaryUnitType' in value) || value['stationaryUnitType'] === undefined) return false;
    if (!('firmwareLastUpdatedAt' in value) || value['firmwareLastUpdatedAt'] === undefined) return false;
    if (!('firmwareCurrentVersion' in value) || value['firmwareCurrentVersion'] === undefined) return false;
    return true;
}

export function StationaryUnitFromJSON(json: any): StationaryUnit {
    return StationaryUnitFromJSONTyped(json, false);
}

export function StationaryUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): StationaryUnit {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'label': json['label'],
        'serialNumber': json['serialNumber'],
        'stationaryUnitType': StationaryUnitTypeFromJSON(json['stationaryUnitType']),
        'firmwareLastUpdatedAt': (new Date(json['firmwareLastUpdatedAt'])),
        'firmwareCurrentVersion': json['firmwareCurrentVersion'],
    };
}

export function StationaryUnitToJSON(json: any): StationaryUnit {
    return StationaryUnitToJSONTyped(json, false);
}

export function StationaryUnitToJSONTyped(value?: StationaryUnit | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'label': value['label'],
        'serialNumber': value['serialNumber'],
        'stationaryUnitType': StationaryUnitTypeToJSON(value['stationaryUnitType']),
        'firmwareLastUpdatedAt': value['firmwareLastUpdatedAt'].toISOString(),
        'firmwareCurrentVersion': value['firmwareCurrentVersion'],
    };
}

